import nookies from "nookies"
import { firebaseAdmin } from "../helpers/auth/admin"
import { LoginContainer } from "../components/auth/login"

export default function Login() {
  return (
    <LoginContainer />
  )
}

export async function getServerSideProps(ctx) {
  try {
    const cookies = nookies.get(ctx)
    const token = cookies.token;

    if (!token) {
      return { props: {} }; 
    }
   
    await firebaseAdmin.auth().verifyIdToken(token);

    ctx.res.writeHead(303, { Location: "/admin/submissions" });
    ctx.res.end();
    return { props: {} };

  } catch (err) {
    nookies.destroy(ctx, "token", { path: "/" });
    return { props: {} };
  }
}

